import React from 'react';

import EmptyList from 'components/EmptyList';
import useStoreTranslation from 'hooks/useStoreTranslation';

export const EmptyTravelsView = () => {
  const { t } = useStoreTranslation();

  return (
    <div>
      <EmptyList
        grey
        title={t('travelReport.emptyTitle')}
        description={t('travelReport.emptyDescription')}
        image="/corporate/images/report-file-xlsx.svg"
        backgroundImage="/corporate/images/group-3.svg"
      />
    </div>
  );
};
